import { createPortal } from 'react-dom';
import { useImperativeHandle, useEffect, useMemo, useRef, useContext, forwardRef, memo } from 'react';
import { applyReactStyle } from "../utils/apply-react-style.js";
import { MapContext } from "./map.js";
import { deepEqual } from "../utils/deep-equal.js";

function getClassList(className) {
  return new Set(className ? className.trim().split(/\s+/) : []);
}

function Popup(props, ref) {
  const {
    map,
    mapLib
  } = useContext(MapContext);
  const container = useMemo(() => {
    return document.createElement('div');
  }, []);
  const thisRef = useRef({
    props
  });
  thisRef.current.props = props;
  const popup = useMemo(() => {
    const options = { ...props
    };
    const pp = new mapLib.Popup(options);
    pp.setLngLat([props.longitude, props.latitude]);
    pp.once('open', e => {
      var _thisRef$current$prop, _thisRef$current$prop2;

      (_thisRef$current$prop = (_thisRef$current$prop2 = thisRef.current.props).onOpen) === null || _thisRef$current$prop === void 0 ? void 0 : _thisRef$current$prop.call(_thisRef$current$prop2, e);
    });
    return pp;
  }, []);
  useEffect(() => {
    const onClose = e => {
      var _thisRef$current$prop3, _thisRef$current$prop4;

      (_thisRef$current$prop3 = (_thisRef$current$prop4 = thisRef.current.props).onClose) === null || _thisRef$current$prop3 === void 0 ? void 0 : _thisRef$current$prop3.call(_thisRef$current$prop4, e);
    };

    popup.on('close', onClose);
    popup.setDOMContent(container).addTo(map.getMap());
    return () => {
      popup.off('close', onClose);

      if (popup.isOpen()) {
        popup.remove();
      }
    };
  }, []);
  useEffect(() => {
    applyReactStyle(popup.getElement(), props.style);
  }, [props.style]);
  useImperativeHandle(ref, () => popup, []);

  if (popup.isOpen()) {
    if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) {
      popup.setLngLat([props.longitude, props.latitude]);
    }

    if (props.offset && !deepEqual(popup.options.offset, props.offset)) {
      popup.setOffset(props.offset);
    }

    if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
      popup.options.anchor = props.anchor;
      popup.setMaxWidth(props.maxWidth);
    }

    if (popup.options.className !== props.className) {
      const prevClassList = getClassList(popup.options.className);
      const nextClassList = getClassList(props.className);

      for (const c of prevClassList) {
        if (!nextClassList.has(c)) {
          popup.removeClassName(c);
        }
      }

      for (const c of nextClassList) {
        if (!prevClassList.has(c)) {
          popup.addClassName(c);
        }
      }

      popup.options.className = props.className;
    }
  }

  return createPortal(props.children, container);
}

export default memo(forwardRef(Popup));
//# sourceMappingURL=popup.js.map